import React, { useMemo } from 'react';
import NeatScheduleMark from '../../../shared/components/brand/NeatScheduleMark';
import './WorkspaceLoadingScreen.css';

const WorkspaceLoadingScreen = ({
  message = 'Preparing your workspace...',
  detail,
  themeMode: themeModeProp,
  showSpinner = true,
}) => {
  const themeMode = useMemo(() => {
    if (themeModeProp === 'light' || themeModeProp === 'dark') return themeModeProp;
    if (typeof window === 'undefined') return 'light';
    return (
      document.documentElement.getAttribute('data-theme') ||
      localStorage.getItem('themeMode') ||
      'light'
    );
  }, [themeModeProp]);

  return (
    <div
      className="workspaceLoading"
      data-theme={themeMode}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={message}
    >
      <div className="workspaceLoading__logoWrap">
        <NeatScheduleMark
          variant={themeMode === 'dark' ? 'dark' : 'light'}
          className="workspaceLoading__logo"
          width={320}
          height={88}
        />
      </div>

      {showSpinner ? <div className="workspaceLoading__spinner" aria-hidden="true" /> : null}

      <p className="workspaceLoading__message">{message}</p>
      {detail ? <p className="workspaceLoading__detail">{detail}</p> : null}
    </div>
  );
};

export default WorkspaceLoadingScreen;
